/**
 * @generated SignedSource<<cc7730377094532e678e904b0e365bfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyntheticActionItemGroupsListChangeMultipleDueDateMutation$variables = {
  dueDate?: any | null;
  noteBlockIds: ReadonlyArray<string>;
};
export type SyntheticActionItemGroupsListChangeMultipleDueDateMutation$data = {
  readonly changeMultipleActionItemDueDate: {
    readonly updatedBlocks: ReadonlyArray<{
      readonly dueDate: string | null;
      readonly id: string;
    }>;
  } | null;
};
export type SyntheticActionItemGroupsListChangeMultipleDueDateMutation$rawResponse = {
  readonly changeMultipleActionItemDueDate: {
    readonly updatedBlocks: ReadonlyArray<{
      readonly dueDate: string | null;
      readonly id: string;
    }>;
  } | null;
};
export type SyntheticActionItemGroupsListChangeMultipleDueDateMutation = {
  rawResponse: SyntheticActionItemGroupsListChangeMultipleDueDateMutation$rawResponse;
  response: SyntheticActionItemGroupsListChangeMultipleDueDateMutation$data;
  variables: SyntheticActionItemGroupsListChangeMultipleDueDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dueDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockIds"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dueDate",
        "variableName": "dueDate"
      },
      {
        "kind": "Variable",
        "name": "noteBlockIds",
        "variableName": "noteBlockIds"
      }
    ],
    "concreteType": "ChangeMultipleActionItemDueDate",
    "kind": "LinkedField",
    "name": "changeMultipleActionItemDueDate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlocks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SyntheticActionItemGroupsListChangeMultipleDueDateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SyntheticActionItemGroupsListChangeMultipleDueDateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "596acf4c075ca55cdb87e07fe49d44dd",
    "id": null,
    "metadata": {},
    "name": "SyntheticActionItemGroupsListChangeMultipleDueDateMutation",
    "operationKind": "mutation",
    "text": "mutation SyntheticActionItemGroupsListChangeMultipleDueDateMutation(\n  $noteBlockIds: [ID!]!\n  $dueDate: Date\n) {\n  changeMultipleActionItemDueDate(noteBlockIds: $noteBlockIds, dueDate: $dueDate) {\n    updatedBlocks {\n      id\n      dueDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "009664941f0aa383cafea8eb67411cee";

export default node;
